import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CustomDevAppTitle, ViewInfoButton } from '../TableTitles/index';
import { DIALOG_TEXT, DIALOG_TITLES, PACKAGE_TYPE_CUSTOM_DEV_APP } from '../../constants/packageTypes';
import TablesPropTypes from '../../propTypes/tables';
import {
    doCustomDevAppPackagesHaveFilters,
    getCustomDevAppPackagesContext,
    getCustomDevAppPackagesForTable,
} from '../../selectors/packages';
import BrowseByType from '../BrowseByType';
import ApiPropTypes from '../../propTypes/api';

class BrowseCustomDevAppPackages extends React.Component {
    state = {
        infoDialogOpen: false,
    };

    onClickViewInfoButton = () => {
        this.setState({ infoDialogOpen: true });
    };

    onCloseInfoDialog = () => {
        this.setState({ infoDialogOpen: false });
    };

    render () {
        const { infoDialogOpen } = this.state;
        const ViewInfoButtonCustomDevApp = (
            <ViewInfoButton
                onClick={this.onClickViewInfoButton}
                infoDialogOpen={infoDialogOpen}
                onCloseInfoDialog={this.onCloseInfoDialog}
                dialogTitle={DIALOG_TITLES[PACKAGE_TYPE_CUSTOM_DEV_APP]}
                dialogText={DIALOG_TEXT[PACKAGE_TYPE_CUSTOM_DEV_APP]}
            />);
        return (
            <BrowseByType
                type={PACKAGE_TYPE_CUSTOM_DEV_APP}
                title={<CustomDevAppTitle button={ViewInfoButtonCustomDevApp} />}
                isCustomDevApp
                {...this.props}
            />
        );
    }
}

BrowseCustomDevAppPackages.propTypes = {
    tableData: TablesPropTypes.tablePageData.isRequired,
    tableContext: ApiPropTypes.apiPageContext.isRequired,
    hasFilters: PropTypes.bool.isRequired,
};

const mapStateToProps = function (state) {
    return {
        tableData: getCustomDevAppPackagesForTable(state),
        tableContext: getCustomDevAppPackagesContext(state),
        hasFilters: doCustomDevAppPackagesHaveFilters(state),
    };
};

export default connect(mapStateToProps)(BrowseCustomDevAppPackages);
